export default __webpack_public_path__ + "static/media/F0005.a4ef2be5.png";